'use strict';

/* globals angular */

const SignupFormRCController = require('./SignupFormRCController');
const SignupRCDirective = require('./SignupRCDirective');

const signupRCForm = angular.module('login.signuprc', [
  'stripe.checkout'
]);

signupRCForm.directive('signupRc', [
  SignupRCDirective
]);

signupRCForm.service('plansRequestRC', ['$http', 'IdentityService', function ($http, IdentityService) {

  const url = IdentityService.getPaymentsApiUri() + 'plans';
  const httpConfig = { url, method: 'GET' };
  return $http(httpConfig);
}]);

signupRCForm.controller('SignupFormRCController', [
  '$http',
  '$location',
  '$rootScope',
  '$scope',
  '$stateParams',
  '$timeout',
  'AnalyticsService',
  'sbAuth',
  'IdentityService',
  'IntercomService',
  'plansRequestRC',
  'RoutingUtil',
  'SocialLoginService',
  SignupFormRCController
]);



// WEBPACK FOOTER //
// ./src/app/login/signupFormRC/index.js